import { Component, ElementRef, EventEmitter, HostListener, OnInit, Output, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { Router } from '@angular/router';
import { ENavigationRoute } from 'src/app/model/enum/navigation-route';
import { CoreData } from 'src/app/tools/core-data/core-data';
import { LoadingTask } from 'src/app/tools/ui/loading-task';
import { environment } from 'src/environments/environment';
import { NotificationManager } from 'src/app/tools/ui/notification-manager';
import { MatSnackBar } from '@angular/material/snack-bar';
const { version: appVersion } = require('../../../../package.json');

@Component({
    selector: 'app-nav-menu',
    templateUrl: './nav-menu.component.html',
    styleUrls: ['./nav-menu.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class NavMenuComponent implements OnInit {
    ENavigationRoute = ENavigationRoute;
    @ViewChild('toggleButton', { read: ElementRef }) toggler: ElementRef;
    @Output() stateChanged = new EventEmitter<string>();
    isExpanded = false;
    Opacity = 0;
    AppName = environment.name;
    AppVersion: string;

    get EurofinsIconPath() {
        return this.CoreData.IsMobile ? 'favicon.ico' : 'assets/eurofins-logo-white.png';
    }

    get DemetraIconPath() {
        return 'assets/Demetra_logo.png';
    }

    constructor(
        private router: Router,
        private snackBar: MatSnackBar,
        public loadingTask: LoadingTask,
        public CoreData: CoreData) {

    }

    @HostListener('window:resize', ['$event'])
    onResize(event) {
        this.isMenuTogglerDisplayed();
    }

    ngOnInit() {
        this.AppVersion = appVersion;
        this.loadingTask.LoadingEmitter.subscribe(x => {
            if (x) {
                this.Opacity = 100;
            } else {
                this.Opacity = 0;
            }
        });
    }

    collapse() {
        this.isExpanded = false;
    }

    toggle() {
        this.isExpanded = !this.isExpanded;
        if (this.isExpanded) {
            this.stateChanged.emit('160px');
        } else {
            this.stateChanged.emit('80px');
        }
    }

    isMenuTogglerDisplayed() {
        return this.toggler && window.getComputedStyle(this.toggler.nativeElement).display !== 'none';
    }

    IsLoggedIn() {
        return this.CoreData.IsLoggedIn;
    }

    logout() {
        if (this.CoreData.ImpersonateAs) {
            this.LogOffAs();
            return;
        }
        this.CoreData.logout();
        this.router.navigate([ENavigationRoute.Login]);
    }



    navigateToSpecificResources(type: number) {
        switch (type) {
            case 1:
                window.open(`${window.location.origin}/assets/RGPD-CGU/Demetra - conditions générales d'utilisation 12-21.pdf`, '_blank');
                break;
            case 2:
                window.open(`${window.location.origin}/assets/RGPD-CGU/Demetra - Mentions légales 12-21.pdf`, '_blank');
                break;
            case 3:
                window.open(`${window.location.origin}/assets/RGPD-CGU/Demetra - RGPD 12-21.pdf`, '_blank');
                break;
            case 4:
                window.open('https://location.eurofins.com/en/', '_blank');
                break;
            case 5:
                window.open('https://www.eurofins.com/fr-fr/#map', '_blank');
                break;
            case 6:
                window.open('https://www.eurofins.com/fr-fr/qui-nous-sommes/', '_blank');
                break;
        }
    }

    canConfigureUser() {
        return !!this.CoreData.RoleAndPermissions?.find(x => x.Name === 'CanConfigureUser');
    }

    LogOffAs() {
        this.CoreData.ImpersonateAs = undefined;
        NotificationManager.handleSuccess('Log Off As {{SelectedUser.Email}}', this.snackBar);
        this.router.navigate([ENavigationRoute.Home]);
    }
}
